module.exports = __webpack_public_path__ + "static/media/thermometer-full.ee43cd51.svg";